export const tableHeaderData = [
    "Product name",
    "Stock",
    "Price",
    "Total sales",
];

export const tableBodyData = [
    {
        productName : "Abstract 3D",
        productDescription : "Lorem ipsum dolor sit amet",
        stock : 32,
        price : 45.99,
        totalSales : 20,
        image : "https://media.istockphoto.com/id/1356565274/photo/modern-abstract-wavy-background.webp?s=2048x2048&w=is&k=20&c=PeytzxlzbJgub2JKrJv2_s8WVd4vzwec4pOKhAohoI8="
    },
    {
        productName : "Abstract 3D",
        productDescription : "Lorem ipsum dolor sit amet",
        stock : 32,
        price : 45.99,
        totalSales : 20,
        image : "https://media.istockphoto.com/id/1356565274/photo/modern-abstract-wavy-background.webp?s=2048x2048&w=is&k=20&c=PeytzxlzbJgub2JKrJv2_s8WVd4vzwec4pOKhAohoI8="
    },
    {
        productName : "Abstract 3D",
        productDescription : "Lorem ipsum dolor sit amet",
        stock : 32,
        price : 45.99,
        totalSales : 20,
        image : "https://media.istockphoto.com/id/1356565274/photo/modern-abstract-wavy-background.webp?s=2048x2048&w=is&k=20&c=PeytzxlzbJgub2JKrJv2_s8WVd4vzwec4pOKhAohoI8="
    },
    {
        productName : "Abstract 3D",
        productDescription : "Lorem ipsum dolor sit amet",
        stock : 32,
        price : 45.99,
        totalSales : 20,
        image : "https://media.istockphoto.com/id/1356565274/photo/modern-abstract-wavy-background.webp?s=2048x2048&w=is&k=20&c=PeytzxlzbJgub2JKrJv2_s8WVd4vzwec4pOKhAohoI8="
    },
    {
        productName : "Abstract 3D",
        productDescription : "Lorem ipsum dolor sit amet",
        stock : 32,
        price : 45.99,
        totalSales : 20,
        image : "https://media.istockphoto.com/id/1356565274/photo/modern-abstract-wavy-background.webp?s=2048x2048&w=is&k=20&c=PeytzxlzbJgub2JKrJv2_s8WVd4vzwec4pOKhAohoI8="
    },
]